import React, { useState, useContext } from 'react';
import { Button, TextField, Grid, Typography, Checkbox, FormControlLabel } from '@mui/material';

import { ManufacturersNewContext } from '../contexts/ManufacturersNewContext';
import axios from '../../utils/axios.utils';

const NewManufacturerForm = ({ onSuccess, showSnackbar = (message: string, severity: 'success' | 'error') => {} }: { onSuccess: () => void, showSnackbar?: (message: string, severity: 'success' | 'error') => void }) => {

  const [formValues, setFormValues] = useState({
    mfr_name: '',
    mfr_enabled: false,
    mfr_enabled_liquid: false,
    mfr_enabled_recipe: false,
    mfr_enabled_seed: false,
    mfr_sync_set_id: '',
    active: true,
  });

  const { formSubmitting, formErrors } = useContext(ManufacturersNewContext);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormValues({
      ...formValues,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await axios.post('api/admin/autotreat_mfr/mfrs/', formValues, {
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}` 
        },
      });

      showSnackbar('Manufacturer created successfully', 'success');
      if (onSuccess) onSuccess();
    } catch (error: any) {
      console.error('Error creating manufacturer:', error);
      const errorMessage = error?.response?.data?.message || 'Failed to create manufacturer. Please try again.';
      showSnackbar(errorMessage, 'error');
    }
  };

  return (
    <>
      <form id="dialog-form" onSubmit={handleSubmit}>
        <Grid container spacing={3} style={{ marginLeft: 0 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              name="mfr_name"
              label="MFR Name"
              fullWidth
              variant="outlined"
              value={formValues.mfr_name}
              onChange={handleInputChange}
              error={!!formErrors?.mfr_name}
              helperText={formErrors?.mfr_name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="mfr_sync_set_id"
              label="MFR Sync Set ID"
              fullWidth
              variant="outlined"
              value={formValues.mfr_sync_set_id}
              onChange={handleInputChange}
              error={!!formErrors?.mfr_sync_set_id}
              helperText={formErrors?.mfr_sync_set_id}
            />
          </Grid>
          {['mfr_enabled', 'mfr_enabled_liquid', 'mfr_enabled_recipe', 'mfr_enabled_seed', 'active'].map((field) => (
            <Grid item xs={12} sm={6} key={field}>
              <FormControlLabel
                control={<Checkbox name={field} checked={formValues[field]} onChange={handleInputChange} />}
                label={field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
              />
            </Grid>
          ))}
        </Grid>
      </form>
    </>
  );
};

export default NewManufacturerForm;
